"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.VibrancyView = void 0;
var react_1 = __importDefault(require("react"));
exports.VibrancyView = react_1["default"].memo(function VibrancyView() {
    throw new Error("VibrancyView from @hiyllo/blur-web should not be rendered");
});
